import styled from 'styled-components';

export const Container = styled.div`
  background: #fff;
  border: 1px solid ${(props) => props.theme.$gray300};
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(33, 53, 74, 0.06);
  padding: 24px;
  margin-top: 24px;

  .progress-head {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 4px 16px;

    .progress-title {
      font-size: 1.05rem;
      font-weight: 500;
      color: ${(props) => props.theme.$gray900};
      margin: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 100%;
    }

    .progress-timer {
      font-size: 0.8rem;
      color: ${(props) => props.theme.$gray600};
      font-variant-numeric: tabular-nums;
    }
  }

  .progress-sub {
    margin: 2px 0 0;
    font-size: 0.85rem;
    color: ${(props) => props.theme.$gray600};
  }

  .progress-track {
    margin-top: 16px;
    height: 6px;
    border-radius: 999px;
    background: ${(props) => props.theme.$gray200};
    overflow: hidden;

    .progress-fill {
      height: 100%;
      border-radius: 999px;
      background: linear-gradient(90deg, #007bff, #009f79);
      transition: width 1s linear;

      &.overdue {
        animation: pi-pulse 1.4s ease-in-out infinite;
      }
    }
  }

  @keyframes pi-pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.55;
    }
  }

  .phase-list {
    margin: 20px 0 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .phase {
    display: flex;
    align-items: flex-start;
    gap: 12px;

    .phase-icon {
      width: 34px;
      height: 34px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      background: ${(props) => props.theme.$gray100};
      color: ${(props) => props.theme.$gray400};
      transition: background 0.2s, color 0.2s;

      i {
        font-size: 19px;
      }
    }

    .phase-text {
      padding-top: 2px;
      min-width: 0;

      .phase-title {
        margin: 0;
        font-size: 0.92rem;
        color: ${(props) => props.theme.$gray400};
        line-height: 1.25;
        transition: color 0.2s;
      }

      .phase-sub {
        margin: 2px 0 0;
        font-size: 0.8rem;
        color: ${(props) => props.theme.$gray600};
      }
    }

    &.done {
      .phase-icon {
        background: ${(props) => props.theme.$bg_green};
        color: ${(props) => props.theme.$primary_green};
      }
      .phase-title {
        color: ${(props) => props.theme.$gray600};
      }
    }

    &.active {
      .phase-icon {
        background: ${(props) => props.theme.$primary_light};
        color: ${(props) => props.theme.$primary};

        i {
          animation: pi-pulse 1.4s ease-in-out infinite;
        }
      }
      .phase-title {
        color: ${(props) => props.theme.$gray900};
        font-weight: 500;
      }
    }
  }

  .progress-actions {
    margin-top: 18px;
    display: flex;
    justify-content: flex-end;
  }
`;
